import { render } from "./VideosTable.vue?vue&type=template&id=3f2e50e0&scoped=true&ts=true"
import script from "./VideosTable.vue?vue&type=script&lang=ts"
export * from "./VideosTable.vue?vue&type=script&lang=ts"

import "./VideosTable.vue?vue&type=style&index=0&id=3f2e50e0&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f2e50e0"]])

export default __exports__